<template>
  <QuestionBase :question="question" :errors="[...serverErrors, ...jsErrors]" :valid="!!data" >
      <InputRadio
          v-model="data"
          :options="advisorRatedOptions"
          :db="db"
          :args="args"
          :skipped="skipped"
          class="radio-options-wide"
          @skipped="skipped=$event"
          @serverErrors="serverErrors=$event"
          @jsErrors="jsErrors=$event"
      />
  </QuestionBase>
</template>

<script>
import { questionLoadHelpers} from "../../helpers/questionLoadHelpers";
import { feedbackOptions } from "../../options/feedbackOptions";

import QuestionBase from "../../QuestionBase";
import InputRadio from "../../inputs/InputRadio";

export default {
  name: 'AdvisorRated',
  mixins: [feedbackOptions, questionLoadHelpers],
  components: {
    InputRadio,
    QuestionBase
  },
  props: {
    value: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: false
    },
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    }
  },
  data () {
    return {
      question: {
        title:  'How would you rate your advisor?',
        subTitle:  'If you dealt with multiple advisors please rate your interactions overall.',
        tip: null
      },
      db: {
        saveLocation: 'feedback_save',
        saveField: 'advisor_rated'
      },
      args: {
        skippable: false,
        required: true,
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>
